import Request from 'utils/request';
import Cookie from 'js-cookie'
import config from 'config/Config';
export default class SiderBarServ {
	static getMenuList(data) {
		return Request({
			url:`api/user/v1/access/user/${Cookie.get(config.cookie.user_id)}/resources`,
			method:'GET',
			data: { filter: '{withNoFirstNode: 1}' },
			headers: data
		});
	}
}


// WEBPACK FOOTER //
// ./src/widget/SiderBar/SiderBarServ.js